import { React, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "../../commonComponents/Buttons";
import CheckBoxTable from "../../commonComponents/Tables/CheckBoxTable";

import { useLockBodyScroll } from "../../../hooks";

import "./removeChallengesModal.scss";
import { LikedIcon, UnlikedIcon, DefaultCover } from "../../../assets";

function RemoveChallengesModal({
  setVisibleRemoveChallengesModal,
  checkedItems,
  setCheckedItems,
  deleteChallenges,
  data,
  challengeType,
}) {
  useLockBodyScroll();
  const { t } = useTranslation();

  const columns = useMemo(() => {
    if (challengeType === "image" || challengeType === "video" || challengeType === "pdf") {
      return [
        {
          Header: t("name"),
          Cell: (tableProps) => (
            <p
              className={
                tableProps.row.original.status === "pending"
                  ? "tableTitleGrey"
                  : undefined
              }
            >
              {tableProps.row.original.title}
            </p>
          ),
        },
        {
          Header: t("picture"),
          Cell: (tableProps) => (
            <img
              className="tableImage"
              alt={t("challenge")}
              src={
                !tableProps.row.original.cover_image
                  ? DefaultCover
                  : tableProps.row.original.cover_image
              }
            />
          ),
        },
        {
          Header: t("likes"),
          Cell: (tableProps) => (
            <div className="likesBlock">
              <img
                className="lileIcon"
                alt={t("challenge")}
                src={tableProps.row.original.liked ? LikedIcon : UnlikedIcon}
              />
              <p>{tableProps.row.original.likes}</p>
            </div>
          ),
        },
      ];
    }
    if (challengeType === "text") {
      return [
        {
          Header: t("name"),
          Cell: (tableProps) => (
            <p
              className={
                tableProps.row.original.status === "pending"
                  ? "tableTitleGrey"
                  : undefined
              }
            >
              {tableProps.row.original.title}
            </p>
          ),
        },
        {
          Header: t("likes"),
          Cell: (tableProps) => (
            <div className="likesBlock">
              <img
                className="lileIcon"
                alt={t("challenge")}
                src={tableProps.row.original.liked ? LikedIcon : UnlikedIcon}
              />
              <p>{tableProps.row.original.likes}</p>
            </div>
          ),
        },
      ];
    }
  }, [challengeType, t]);

  return (
    <>
      <section className="modalBg">
        <section className="modalBody removeChallenges">
          <div className="dialog-header">
            <h3 className="heading-3">{t("deleteChoose")}</h3>
            <legend>{t("deleteModalWarning")}</legend>
          </div>

          <div className="table-container-remove-table">
            <CheckBoxTable
              setCheckedItems={setCheckedItems}
              columns={columns}
              data={data}
            />
          </div>

          <div className="buttons dialog-footer">
            <Button
              label={t("cancel")}
              viewType="cancelBtn"
              onClick={() => setVisibleRemoveChallengesModal(false)}
            />
            <Button
              label={`${t("delete")} ${checkedItems?.length} ${t(
                "multipleChallenge"
              )}`}
              viewType="removeBtn"
              onClick={() => deleteChallenges()}
            />
          </div>
          <Button
            iconClassName="hasIcon--close"
            viewType="transparentIcon"
            onClick={() => setVisibleRemoveChallengesModal(false)}
          />
        </section>
      </section>
    </>
  );
}

export default RemoveChallengesModal;
